import React from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '../../../base/tooltip/components/Tooltip';
/**
 * React {@code Component} for showing a moderator pinned indicator.
 *
 * @param {IProps} props - The props of the component.
 * @returns {ReactElement}
 */
const ModeratorPinnedIndicator = ({ tooltipPosition }) => {
    const { t } = useTranslation();
    return (React.createElement(Tooltip, { content: t('videothumbnail.moderatorPinned'), position: tooltipPosition },
        React.createElement("div", { className: 'moderator-pinned-indicator' }, "\uD83D\uDCCC")));
};
export default ModeratorPinnedIndicator;
